import React from 'react';

import styled from '@emotion/styled';
import { text, black01, black03 } from '../../_style';

export default class Text extends React.Component {
  render() {
    const Text = styled.p`
      color: ${this.props.lead ? black01 : black03};
      ${text('16px', 30 / 16)}
      display: inline-block;
      & + & {
        padding-top: 1.75em;
      }
      small {
        padding-top: 7px;
      }
    `
    return(
      <Text lead={this.props.lead}>{this.props.children}</Text>
    );
  }
}
